import React from 'react';

import classNames from 'classnames';

import './PageSubheader.sass';

interface PageSubheaderProps extends React.PropsWithChildren {
  title?: React.ReactNode;
  className?: string;
}

function PageSubheader({
  title = undefined,
  children = undefined,
  className = undefined,
}: PageSubheaderProps): React.JSX.Element {
  return (
    <div className={classNames('PageSubheaderV2', className)}>
      {title}
      {children}
    </div>
  );
}

export { PageSubheader };
